'use client';

import { Icon } from '@iconify/react';
import Link from 'next/link';

import {
    type ReelStudioTab,
    reelStudioHref,
    type VideoStudy,
} from '@/lib/reel-studio/agent/blocks';

/** "Open in Reel Studio": the same study and question, in the detailed editing view. */
export function OpenInReelStudio({ scope, tab }: { scope: VideoStudy; tab?: ReelStudioTab }) {
    return (
        <Link
            href={reelStudioHref(scope, tab)}
            className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline"
        >
            Open in Reel Studio
            <Icon icon="lucide:arrow-up-right" width={14} height={14} />
        </Link>
    );
}
